<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4">
                <div class="mt-2 mb-3">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2"
                      >{{esellerBrandTotalRows}}</span
                    > Record(s)
                  </h5>
                </div>
              </div>
              <!-- Search and button -->
              <div class="col-md-8 col-sm-8 text-right"> 
                <div class="row justify-content-end">
                  <div class="w-auto mb-2 
                    d-flex
                    flex-wrap 
                    mt-md-0
                    gap-2
                    mb-3
                  ">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary"
                      data-bs-toggle="modal"
                      @click="openCreateModal" v-if="false"
                      ><i class="uil uil-plus me-1"></i> Create Seller</a
                    >
                    <router-link v-if="esuppliesSellerModule.access.create"
                      :to="{ name: 'Add Seller Account Brand', params: { id: 0 }}" class="tc-white">
                      <button class="btn btn-primary" >
                          <i class="uil uil-plus me-1"></i> Create Seller
                      </button>
                    </router-link>

                    <a class="btn btn-secondary"
                      @click="refresh"
                      ><feather
                        type="refresh-ccw"
                        size="16"
                        class="icon nav-icon"
                      ></feather
                      >&nbsp;&nbsp; Refresh</a
                    >
                  </div> 
                </div>
              </div>
            </div>

            <div class="d-flex flex-wrap mt-3 mb-3">
                <div class="me-3">
                  <b-form-group
                  > 
                    <template v-slot:description>
                      <div class="d-flex w-100 justify-content-end"><div class="text-end">Search Keyword</div></div>
                    </template>
                    <div class="d-flex">
                    <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                      v-model="lookupParams.field"
                      :options="searchOptions"
                    ></b-form-select>
                    <b-form-input v-on:keyup.enter="search" v-model="lookupParams.keyword" class="rounded-0"></b-form-input>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-3 w-200px">
                  <b-form-group> 
                    <template v-slot:description>
                      <div class="d-flex w-100 justify-content-end"><div class="text-end">Filter by business category</div></div>
                    </template>
                    <multiselect
                      v-model="brandBusinessCategory"
                      :options="businessCategoryOptions"
                      track-by="value"
                      label="text"
                      select-label="Click to select"
                      deselect-label="Click to remove"
                      placeholder="Select business category"
                      :allow-empty="false"
                      :preselect-first="true"
                    ></multiselect>
                  </b-form-group>
                </div>
                <div class="me-3 w-300px">
                  <b-form-group>
                    <template v-slot:description>
                      <div class="d-flex w-100 justify-content-end"><div class="text-end">Filter by product category</div></div>
                    </template>
                    <multiselect
                      v-model="brandProductCategories"
                      :options="productCategoryOptions"
                      track-by="value"
                      label="text"
                      select-label="Click to select"
                      deselect-label="Click to remove"
                      placeholder="Select product category"
                      :allow-empty="false"
                      :preselect-first="true"
                    ></multiselect>
                  </b-form-group>
                </div>
                <div class="me-3 w-350px">
                  <b-form-group>
                    <template v-slot:description>
                      <div class="d-flex w-100 justify-content-end"><div class="text-end">Order by</div></div>
                    </template>
                    <div class="d-flex">
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                        v-model="pagination.sort"
                        :options="sortOptions"
                      ></b-form-select>
                      <b-form-select class="form-select rounded-0 rounded-start shadow-none"
                        v-model="pagination.orderDesc"
                        :options="sortOrderOptions"
                      ></b-form-select>
                    </div>
                  </b-form-group>
                </div>
                <div class="me-2">
                  <b-form-group
                    label=""
                  >
                    <b-button variant="primary" type="button" @click="search" class="px-2 d-flex align-items-center">
                      <div><i class='bx bx-search bx-fw'></i></div>
                      <div>Search</div>
                    </b-button>
                  </b-form-group>
                </div>
                <div>
                  <b-form-group label="">
                    <b-button variant="primary" type="button" @click="onExport" class="px-2 btn btn-primary h-fit">
                      <i class='uil uil-export me-1'></i> Export
                    </b-button>
                  </b-form-group>
                </div>
              </div>

            <template>
              <div class="row">
                <brand-item
                  v-for="(brand, index) in brands" 
                  v-bind:key="index"
                  v-bind:brand="brand"
                  @edit="editBrand(brand)"
                  @delete="deleteBrand(brand)"
                  />
              </div>
            </template>
            <div class="row g-0 text-center" v-if="esellerBrandTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="esellerBrandTotalRows != 0 && esellerBrandTotalRows > 12">
              <!-- end col -->
              <div class="col-sm-6 d-flex align-items-center">
                <div class="me-2"><strong>Display</strong></div>
                <b-form-select
                  :options="displayOptions"
                  v-model="pagination.rows"
                  @input="listBrands"
                  class="form-select display-count" />
              </div>
              <div class="col-sm-6" v-if="esellerBrandNoOfPage > 1">
                <div class="row">
                  <div class="col">
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="pagination.page"
                        @input="listBrands"
                        :total-rows="esellerBrandTotalRows"
                        :per-page="pagination.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandItem from './BrandItem';
import { esellerMethods, esellerComputed, layoutMethods, productListComputed, productListMethods, exportMethods,erpFixMessages, erpUserRolesMethods  } from '@/state/helpers';
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
import { getModuleAccess } from '@/router/helper.js'

export default {
  components: {
    BrandItem,
    Multiselect
  },
  data(){
    return {
      folder: "seller-brands",
      isCreateModal: false,
      isEditModal: false,
      displayOptions: [
        {text: '12', value: 12},
        {text: '24', value: 24},
        {text: '36', value: 36},
        {text: '48', value: 48},
        {text: '60', value: 60},
        {text: '72', value: 72},
        {text: '84', value: 84},
        {text: '96', value: 96},
        {text: '108', value: 108},
        {text: '120', value: 120},
      ],
      pagination: {
        rows: 12,
        page: 1,
        keyword: '',
        field: '',
        business_category: '',
        product_category: '',
        sort: 'brandName',
        orderDesc: false
      },
      lookupParams: {
        keyword: '',
        field: '',
        business_category: '',
        product_category: ''
      },
      searchOptions: [
        {text: 'Search All', value:''},
        {text: 'Brand Name', value:'name'},
        {text: 'Brand Description', value:'description'},
        {text: 'Organization Email', value:'email'}
      ],
      sortOptions: [
        {text: 'Brand Name', value:'brandName'},
        {text: 'Brand Description', value:'brandDescription'},
        {text: 'Brand Category', value:'brandCategory'}
      ],
      sortOrderOptions: [
        {text: 'ASC', value:false},
        {text: 'DESC', value:true}
      ],
      esuppliesSellerModule: {
        access: {
          create: true,
        }
      }
    }
  },
  methods: {
    ...layoutMethods,
    ...esellerMethods,
    ...productListMethods,
    ...exportMethods,
    ...erpUserRolesMethods,
    async onExport(){
      var self = this;
      await this.search().then(function(){
        console.log("check this:",self.esellerBrandTotalRows);
        if(self.esellerBrandTotalRows ==0 ){
          Swal.fire("Failed!", self.exportNullPrompt, "warning");
        }else{
          let params = Object.assign(
            self.pagination, 
            self.lookupParams, 
            {
              module: 'esupplies_brand',
              email: JSON.parse(localStorage.getItem('userData')).email
            });

          delete params.page;//export then search
          delete params.rows;
          
          self.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        }
      });
    },
    clearLogo(){
      this.brandLogo = {
        filename: null,
        type: null,
        base64: null
      }
    },
    openCreateModal(){
      this.isCreateModal = true;
      this.clearBrand();
    },
    refresh(){
      this.pagination = {
        rows: 12,
        page: 1,
        keyword: '',
        field: 'name',
        business_category: '',
        product_category: '',
        sort: 'brandName',
        orderDesc: false
      };
      this.lookupParams = {
        keyword: '',
        field: 'name',
        business_category: '',
        product_category: ''
      }
      this.listBrands();
    },
    editBrand(brand){
      // redirect to new page of brand item
      this.$router.push(
        this.$route.query.redirectFrom || {
          name: "Add Seller Account Brand", params: { id: brand.brandId }
        }
      );
    },
    async listBrands(){
      await this.listSellerBrands(this.pagination);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async search(){
      this.pagination.page = 1;
      this.pagination = Object.assign(this.pagination, this.lookupParams);
      await this.listBrands();
    },
  },
  computed: {
    ...esellerComputed,
    ...productListComputed,
    ...erpFixMessages,
    brandProductCategories: {
      get(){
        var productCategory = null;
        this.productCategoryOptions.forEach(b => {
          if(b.value == this.lookupParams.product_category){
            productCategory = b;
          }
        });
        return productCategory;
      },
      set(productCategory){
        if(productCategory){
          this.lookupParams.product_category = productCategory.value;
        } else {
          this.lookupParams.product_category = "";
        }
      }
    },
    brandBusinessCategory: {
      get(){
        var businessCategory = null;
        this.businessCategoryOptions.forEach(b => {
          if(b.value == this.lookupParams.business_category){
            businessCategory = b;
          }
        });
        return businessCategory;
      },
      set(businessCategory){
        if(businessCategory){
          this.lookupParams.business_category = businessCategory.value;
        } else {
          this.lookupParams.business_category = "";
        }
      }
    },
    productCategoryOptions: {
      get(){
        var options = [{text: 'All', value:''}];
        this.productGroups.forEach(group => {
          options.push({ 'text': group.groupName, 'value': group.groupId });
        });
        return options;
      }
    },
    businessCategoryOptions: {
      get(){
        var options = [{text: 'All', value:''}];
        this.categories.forEach(category => {
          options.push({ 'text': category.businessCategoryName, 'value': category.businessCategoryId });
        });
        return options;
      }
    }
  },
  async mounted(){
    this.listProductGroups({ rows: 99999, sort: 'name', orderDesc: false });
    this.listSellerCategories({ rows: 99999, sort: 'name', orderDesc: false });
    this.listBrands();
    this.changeTitle({title: 'E-Seller Brands'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'E-Seller', to: { name: 'ESeller'} },
        { text: 'Brands', to: { name: 'ESeller Brand'} }
      ]
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'eSupplies', 'Sellers')
      .then((access) => this.esuppliesSellerModule.access = access);
  
  }
}
</script>

<style>
.m-150px {
  min-width: 150px;
}

.w-300px {
  width: 300px;
}

.w-350px {
  width: 350px;
}

.w-200px {
  width: 200px;
}

.multiselect.invalid .multiselect__tags {
  border-color: #f34e4e;
  padding-right: calc(1.5em + 0.94rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f34e4e'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f34e4e' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}

.invalid ~ .invalid-feedback {
  display: block;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #f8f9fa;
  color: #495057;
}

.multiselect__tag {
  background-color: #e73092 !important;
  border-color: #e73092 !important;
  margin-bottom: 0 !important;
  font-weight: 400 !important;
}

.multiselect__tag-icon:after {
  color: #fff !important;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background-color: #e73092 !important;
}

.display-count {
  width: 70px;
}
</style>